import { useLocation } from '@gatsbyjs/reach-router';
import { navigate } from 'gatsby';
import { Entity, Pages, Product } from '../enums';

const isDev = process.env.NODE_ENV === 'development';

export const useRoute = () => {
  const location = useLocation();

  const product =
    Object.values(Product).find((value) => {
      return location.pathname.includes(value);
    }) ?? Product.iMedicalCard;

  const entity =
    Object.values(Entity).find((value) => {
      return location.pathname.includes(value);
    }) ?? Entity.TAKAFUL;

  const step =
    Object.values(Pages).find((value) => {
      return location.pathname.includes(value);
    }) ?? Pages.Quotation;

  const redirect = (pathname: string) => {
    // navigate with append path prefix if have
    navigate(`/${product}/${entity}/${pathname}${location.search}`);
  };

  const queries = new URLSearchParams(location.search);

  return {
    step,
    queries,
    product: product as Product,
    entity: entity as Entity,
    redirect,
  };
};

export function useGetHost() {
  return useLocation().host;
}

export function useProductType(): string {
  const location = useLocation();
  const paths = location.pathname.split('/');

  // local: /onemedical/[takaful]/quotation
  // remote: /edp/life/onemedical/[takaful]/quotation
  return paths[isDev ? 1 : 3];
}
